export default {
	addNetwork: 'Ajouter un réseau',
	editNetwork: 'Modifier un réseau',
	networkName: 'Nom du réseau',
	networkNameLabel: 'Réseau',
}
